import axios from "axios";
import { apiVariable } from "./apiVariable";
import { RecruitingStatsDto } from "../interfaces/Recruiting/recruitingStats";

export const getRecruitingStats = async (
  token: string,
  date?: string,
  startDate?: string
): Promise<RecruitingStatsDto> => {
  const params: { date?: string; startDate?: string } = {};
  if (date) {
    params.date = date;
  }
  if (startDate) {
    params.startDate = startDate;
  }

  const { data } = await axios.get<RecruitingStatsDto>(
    `${apiVariable}/recruiting/stats`,
    {
      params: Object.keys(params).length ? params : undefined,
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  return data;
};
